module.exports = {"340711001":"桥南街道","340711002":"安矿街道","340711100":"铜山镇","340711101":"大通镇","340711102":"老洲镇","340711103":"陈瑶湖镇","340711104":"周潭镇","340711198":"郊区直辖村级区划","340711200":"灰河乡","340711401":"大桥经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340711.json
// module id = 1194
// module chunks = 0